// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LineDashedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LineDashedIcon" ref={forwardedRef} {...props}>
      <path d="M1.875 11.116h2.25v-2.25h-2.25z" />
      <path d="M8.75 11.116H6.5v-2.25h2.25z" />
      <path d="M11.135 11.116h2.25v-2.25h-2.25z" />
      <path d="M15.875 11.133h2.25v-2.25h-2.25z" />
    </SvgIcon>
  );
});

/**
 * Use to give different chart line options
 * @public
 */
export const LineDashedIcon = /* @__PURE__ */ Object.assign(
  LineDashedIconComponent,
  { displayName: 'LineDashedIcon' },
);
